"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _SSES3_1 = require("./_SSES3");
var _SSEKMS_1 = require("./_SSEKMS");
exports._InventoryEncryption = {
    type: "structure",
    required: [],
    members: {
        SSES3: {
            shape: _SSES3_1._SSES3,
            locationName: "SSE-S3"
        },
        SSEKMS: {
            shape: _SSEKMS_1._SSEKMS,
            locationName: "SSE-KMS"
        }
    }
};
//# sourceMappingURL=_InventoryEncryption.js.map